import { TIER } from 'utilsTS/dom';
import { getContainerWidths } from './getContainerWidths';

const DEFAULT_TIER = TIER.LG;

const TIER_WIDTH = getContainerWidths();

export { TIER, DEFAULT_TIER, TIER_WIDTH };
